// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__Uk5LY","footer":"ModalUpdate_footer__3w1y-"};